import { KeyboardDatePicker } from '@material-ui/pickers';

import styled from 'styled-components/macro';

type DateProps = React.ComponentProps<typeof KeyboardDatePicker>;

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
  .MuiFilledInput-root {
    background: #fff;
    border-radius: 0.625rem;
  }
  .MuiFilledInput-root.Mui-disabled {
    background-color: rgba(0, 0, 0, 0.12);
  }
  border-width: 2px;
  border-style: solid;
  border-color: #eaeaea;
  margin: 0;
  box-shadow: 0px 3px 2px #00000005;
  input {
    padding: 0.875rem;
  }
  border-radius: 0.625rem;

  .MuiFilledInput-adornedEnd {
    padding-right: 0;
  }

  @media screen and (max-width: 470px) {
    .MuiInputAdornment-positionEnd {
      margin-left: -22px;
    }
  }
` as React.ComponentType<DateProps>;
